export default "__VITE_ASSET__MdgOQA2XpPQ_$IYxvTwusQ__"